import { Box, Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Title from '../../SpiderWebSite/components/Title'
import { IReduxState } from '../../store'
import { IListeSouscriptionFocusEleve, IParentStudentItem, setdataFiltered } from '../../store/focusEcoleSlice'
import Liste from './Liste'
import OptionFilter from './OptionFilter'
import SearchBar from './SearchBar'
import SearchBarByEtab from './SearchBarByEtab'
import Statistique from './Statistique'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import GetAppIcon from '@mui/icons-material/GetApp'; // Icône pour le bouton
import { Tooltip, IconButton } from "@mui/material";
// import  PrintEtat from './Etat/print'
import FileOpenIcon from '@mui/icons-material/FileOpen';
import { formatDate } from '../../util/functions'


export interface IOptionChoisie {
    optionChoisie: string;
}

export default function ListeSouscription() {


    const dispatch = useDispatch();
    const students = useSelector((state: IReduxState) => state.focusEcole.students);
    const currentEtab = useSelector((state: IReduxState) => state.focusEcole.currentEtab);
    console.log("🚀 ~ ListeSouscription ~ currentEtab:", currentEtab)
    const dataListeSouscriptionsFocus = useSelector((state: IReduxState) => state.focusEcole.dataListeSouscriptionsFocus);
    const [optionState, setOptionState] = useState<IOptionChoisie>({ optionChoisie: "tout" })
    // const [currentEtab, setCurrentEtab] = useState<any>({})
    const [search, setSearch] = React.useState("");
    const [localStudentDatasFiltered, setLocalStudentDatasFiltered] = useState<IParentStudentItem[]>([...students])
    const [choisirAuHasard, setChoisirAuHasard] = useState<any>({})
    const [loadingChoise, setLoadingChoise] = useState(false)
    const [generateLoading, setGenerateLoading] = useState(false)

    const dataFiltered = useSelector((state: IReduxState) => state.focusEcole.dataFiltered);
    const ListeSouscriptionsFocus = useSelector((state: IReduxState) => state.focusEcole.ListeSouscriptionsFocus);


    /**
     * Filtrer la liste en fonction du status (payé, non payé) puis par etablissement.
     */
    useEffect(() => {
        const { optionChoisie } = optionState;
        const { codeEtab } = currentEtab;

        //obtenir tous les élèves 
        const tousLesEleves =
            optionChoisie === 'tout'
                ? [...students]
                : students.filter(item => item.status === 0 || item.status === 1 || item.status === 2)
        // console.log("🚀 ~ file: index.tsx:62 ~ useEffect ~ tousLesEleves:", tousLesEleves)


        //obtenir tous les élèves ayant payé la souscription
        const tousLesElevesAyantPaye =
            optionChoisie !== 'souscrit'
                ? [...tousLesEleves]
                : tousLesEleves.filter(item => item.status !== 0);
        // console.log("🚀 ~ file: index.tsx:71 ~ useEffect ~ tousLesElevesAyantPaye:", tousLesElevesAyantPaye)


        //obtenir tous les élèves n'ayant pas payé la souscription
        const tousLesElevesNAyantPasPaye =
            optionChoisie !== 'nonsouscrit'
                ? [...tousLesElevesAyantPaye]
                : tousLesElevesAyantPaye.filter(item => item.status === 0);
        // console.log("🚀 ~ file: index.tsx:78 ~ useEffect ~ tousLesElevesNAyantPasPaye:", tousLesElevesNAyantPasPaye)


        //obtenir tous les élèves d'un etablissement

        const tousLesElevesParEtab =
            !codeEtab || codeEtab === ""
                ? [...tousLesElevesNAyantPasPaye]
                : tousLesElevesNAyantPasPaye.filter(item => item.codeEtab === currentEtab.codeEtab);


        //obtenir une occurence dans la liste lorqu'on tape dans le champ de saisi
        const eleveSelonLeMotCleSaisi =
            search.length === 0
                ? [...tousLesElevesParEtab]
                : tousLesElevesParEtab.filter(item => {
                    const value: any = `${item.nomEleve} ${item.prenomEleve} ${item.codeEtab} ${item.libEtab} ${item.numeroCellulaire}`;
                    return value.toLowerCase().includes(search.toLowerCase());
                });

        dispatch(setdataFiltered(eleveSelonLeMotCleSaisi))
        setLocalStudentDatasFiltered(eleveSelonLeMotCleSaisi)
    }, [optionState, currentEtab, search]);


    const exportToExcel = () => {
        // Vérifie si la liste des souscriptions est vide ou inexistante
        if (!dataListeSouscriptionsFocus || dataListeSouscriptionsFocus.length === 0) {
            console.warn("Aucune donnée à exporter");
            return;
        }

        // Convertit les données en un format compatible avec une feuille Excel
        const worksheet = XLSX.utils.json_to_sheet(
            dataListeSouscriptionsFocus.map(item => ({
                Année_Scolaire: item.anneeScolaire,
                Code_Etablissement: item.codeEtab,
                Libellé_Etablissement: item.libelleEtab,
                Nombre_Total_Souscriptions: item.nombreTotalSouscriptions,
                status: item.status
            }))
        );

        // Crée un nouveau classeur Excel
        const workbook = XLSX.utils.book_new();

        // Ajoute la feuille de calcul au classeur
        XLSX.utils.book_append_sheet(workbook, worksheet, "Souscriptions");

        // Convertit le classeur en un buffer Excel
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Crée un fichier Blob à partir du buffer
        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        // Télécharge automatiquement le fichier avec un nom basé sur la date du jour

        const now = new Date();
        const date = now.toISOString().split('T')[0]; // YYYY-MM-DD
        const time = now.toTimeString().split(' ')[0].replace(/:/g, '-'); // HH-mm-ss
        //   saveAs(dataBlob, `Liste_Élèves_${date}_${time}.xlsx`);
        saveAs(data, `Souscriptions_${date}_${time}.xlsx`);
    };


    const exportListeSouscription = (data: IParentStudentItem[]) => {

        if (!data || data.length === 0) {
            console.warn("Aucune donnée à exporter");
            return;
        }

        // Convertit les données du tableau en format compatible avec Excel
        const worksheet = XLSX.utils.json_to_sheet(
            data.map((item, index) => ({
                Numéro: index + 1,
                Année_Scolaire: item.anneeScolaire,
                Code_Etablissement: item.codeEtab,
                Lib_Etablissement: item.libEtab,
                Nom_Prenom_Élève: `${item?.nomEleve ?? ""} ${item?.prenomEleve ?? ""}`,
                Date_Naissance: item.dateNaissance,
                Matricule: item?.matricule ?? "",
                Classe: item.libelleClasseCourt ?? "",
                Nom_Prenom_Parent: item.nomPrenomParent,
                Téléphone: item.numeroCellulaire,
                Filiation: item.filiation,
                Statut: item.status === 1 ? "Parent" : "Etablis",
            }))
        );

        // Crée un nouveau classeur
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Liste_Élèves");

        // Convertit et télécharge le fichier Excel
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const now = new Date();
        const date = now.toISOString().split('T')[0]; // YYYY-MM-DD
        const time = now.toTimeString().split(' ')[0].replace(/:/g, '-'); // HH-mm-ss

        saveAs(dataBlob, `Liste_Élèves_${date}_${time}.xlsx`);
        // saveAs(dataBlob, `Liste_Élèves_${new Date().toISOString().split('T')[0]}.xlsx`);
    };


    // extrait les eleves qui ont souscrit depuis 2023 à aujourd'hui. 
    const exportListeSouscriptionFocus = (data: IListeSouscriptionFocusEleve[]) => {

        if (!data || data.length === 0) {
            console.warn("Aucune donnée à exporter");
            return;
        }

        // Convertit les données du tableau en format compatible avec Excel
        const worksheet = XLSX.utils.json_to_sheet(
            data.map((item, index) => ({
                // Numéro: index + 1,
                Année_Scolaire: item.anneeScolaire,
                Code_Etablissement: item.codeEtab,
                Lib_Etablissement: item.libEtab,
                // Identifiant_Eleve: item.idEleve,
                Matricule: item?.matricule ?? "",
                Nom_Prenom_Élève: `${item?.nomEleve ?? ""} ${item?.prenomEleve ?? ""}`,
                Classe: item.libelleClasseCourt ?? "",
                Statut: item.status === 1 ? "Parent" : "Ecole",
                Téléphone: item.numeroCellulaire,
                date_Souscription: formatDate(item.dateSouscription),
            }))
        );

        // Crée un nouveau classeur
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Liste_focus_eleve_souscription");

        // Convertit et télécharge le fichier Excel
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const now = new Date();
        const date = now.toISOString().split('T')[0]; // YYYY-MM-DD
        const time = now.toTimeString().split(' ')[0].replace(/:/g, '-'); // HH-mm-ss
        saveAs(dataBlob, `Liste_Élèves_souscription_${date}_${time}.xlsx`);
        // saveAs(dataBlob, `Liste_Élèves_souscription_${new Date().toISOString().split('T')[0]}.xlsx`);
    };



    return (
        <Box>
            <Grid container spacing={2} style={{ background: "#F7F7F7" }}>

                <Grid item xs={12} md={12} sm={12} lg={12}><Title intitule='Liste de suivi des souscriptions' /></Grid>

                <Grid item xs={12} md={6} sm={6} lg={3}>
                    <OptionFilter
                        optionState={optionState}
                        setOptionState={setOptionState}
                    />
                </Grid>

                <Grid item xs={12} md={6} sm={6} lg={3}>
                    <SearchBarByEtab
                        localStudentDatasFiltered={localStudentDatasFiltered}
                        setLocalStudentDatasFiltered={setLocalStudentDatasFiltered}
                    />
                </Grid>

                <Grid item xs={12} md={6} sm={6} lg={2}>
                    <SearchBar
                        search={search}
                        setSearch={setSearch}
                    />
                </Grid>

                <Grid item xs={12} md={6} sm={6} lg={3}>
                    <Statistique
                        localStudentDatasFiltered={localStudentDatasFiltered}
                    />
                </Grid>

                <Grid item xs={12} md={6} sm={6} lg={1}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={5}
                >

                    {/* <PrintEtat /> */}

                    {/* <Tooltip title="Liste de suivi des souscriptions Focus">

                        <Button color="primary"
                            onClick={() => exportListeSouscription(dataFiltered)}
                        >
                            <FileOpenIcon />

                        </Button>

                    </Tooltip> */}

                    <Tooltip title="Etablissements ayant souscrit">

                        <IconButton color="primary"
                            onClick={exportToExcel}>
                            <GetAppIcon />
                        </IconButton>

                    </Tooltip>


                    <Tooltip title="Liste des élèves souscriptions focus">
                        <Button color="primary"
                            onClick={() => exportListeSouscriptionFocus(ListeSouscriptionsFocus)}
                        >
                            {/* Telecharger  */}
                            <FileOpenIcon />

                        </Button>

                    </Tooltip>

                </Grid>

            </Grid>

            <Liste
                localStudentDatasFiltered={localStudentDatasFiltered}
            />
        </Box>
    )
}
